import React, { Component } from 'react';
import classNames from 'classnames';
import Chains from './chains';
import Segments from './segments';
import Turnover from './turnover';
import Size from './size';
import Store from './store';
import { UnitsVisibility } from '../../../districts/types/units-visibility';
import './styles.scss';


class Filters extends Component {

    registeredFilters = [];
    pendingCallback = null;

    state = {
        filters: null,
        filteredUnits: null,
        selectedSourceDistrictId: ''
    };

    componentDidUpdate(prevProps, prevState) {
        // Execute callback after state update if there's a pending callback
        if (prevState.filteredUnits !== this.state.filteredUnits) {            
            this.props.applyFilters(this.state.filteredUnits, this.state.filters);
            
            //const callback = this.pendingCallback;
            //this.pendingCallback = null;
            //callback(this.state.filteredUnits);
        }
    }

    registerFilter(filter) {
        this.registeredFilters.push(filter);


        //Filter when all filters registered
        if (this.registeredFilters.length === 4) {
            /*this.previewFilter((filteredUnits) => {
                this.props.setDataForSelected(filteredUnits)
            });*/
        }
    }

    previewFilter(cb) {
        let filteredUnits = [...this.props.allUnits];
        let filters = {};

        this.registeredFilters.forEach(f => {

            const filterData = f.filter(filteredUnits);
            filteredUnits = filterData.filteredUnits;
            filters = {
                ...filters,
                ...filterData.filter
            };
        });

        // Store callback to execute after state update
        this.pendingCallback = cb;

        this.setState({
            filteredUnits,
            filters
        });
    }

    resetFilters() {
        this.registeredFilters.forEach(f => {
            f.reset();
        });
    }

    handleSourceDistrictChange(event) {
        this.setState({
            selectedSourceDistrictId: event.target.value
        });
    }

    handleFetchFiltersFromDistrict() {
        const { selectedSourceDistrictId } = this.state;
        if (!selectedSourceDistrictId || !this.props.applyFiltersFromDistrict) {
            return;
        }

        this.props.applyFiltersFromDistrict(selectedSourceDistrictId);
    }

    toggleCopyingFilters() {
        if (!this.props.onToggleCopyingFilters) {
            return;
        }

        this.props.onToggleCopyingFilters();
    }

    render() {
        const props = this.props;
        if (!props.filters) return null;
        const sourceDistrictOptions = Array.isArray(this.props.sourceDistrictOptions)
            ? this.props.sourceDistrictOptions
            : [];
        
        const unitLocalization = this.props.type === 'foodservice' ? 'enheter' : 'butiker';

        return (
            <section className={classNames({
                'map-filters': true,
                'map-filters--is-open': true
            })}>
                <div className="map-filters__modal">
                    <header className="map-filters__header">
                        <h2 className="map-filters__heading">Filter</h2>
                        <button className="map-filters__edit-button" type="button" onClick={() => this.toggleCopyingFilters()}><span>Kopiera filter från annat distrikt</span></button>
                    </header>
                    <div className="map-filters__modal-content">
                        {this.props.isCopyingFiltersOpen && (
                            <div className="map-filters__copy-filters">
                                <label className="map-filters__copy-filters-label" htmlFor="copy-filters-from-district">
                                    Kopiera filter från
                                </label>
                                <div className="map-filters__copy-filters-controls">
                                    <select
                                        id="copy-filters-from-district"
                                        className="map-filters__copy-filters-select"
                                        value={this.state.selectedSourceDistrictId}
                                        onChange={(event) => this.handleSourceDistrictChange(event)}
                                    >
                                        <option value="">Välj distrikt</option>
                                        {sourceDistrictOptions.map((districtOption) => (
                                            <option key={districtOption.value} value={districtOption.value}>
                                                {districtOption.label}
                                            </option>
                                        ))}
                                    </select>
                                    <button
                                        className="map-filters__copy-filters-button"
                                        type="button"
                                        disabled={!this.state.selectedSourceDistrictId}
                                        onClick={() => this.handleFetchFiltersFromDistrict()}
                                    >
                                        Kopiera
                                    </button>
                                </div>
                            </div>
                        )}

                        {props.type !== 'foodservice' &&
                            <Turnover {...props} 
                                heading="Omsättning"
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />
                        }

                        {props.type === 'foodservice' &&
                            <Segments {...props} 
                                    registerFilter={(filter) => this.registerFilter(filter)} 
                                    previewFilter={() => this.previewFilter()} />
                        }

                        <Chains {...props} 
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />

                        {props.type !== 'foodservice' &&
                            <Size {...props} 
                                heading="Säljyta"
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />
                        }
                        <Store {...props} 
                            registerFilter={(filter) => this.registerFilter(filter)} 
                            previewFilter={() => this.previewFilter()}
                            type={props.type} />

                        <footer className="map-filters__modal-footer">
                            <button className="map-filters__reset" type="button" onClick={() => this.resetFilters()}>Återställ filter</button>
                        </footer>
                    </div>
                </div>
            </section>
        );
    }
};

export default Filters;